import type { LoggerService } from '@/services/abstract/LoggerService';
import type { MessageHandlerResult } from '@/services/abstract/poc/MessagingService';
import type { HeliaNode } from '@/types/poc/helia';
import type { LibP2pWithServices } from '@/types/poc/libp2p';
import type { MessageHandler, MessagePayload } from '@/types/poc/message';

type FileKeyReadyForDownloadAcknowledgedVariant = Extract<
  MessageHandlerResult,
  { type: 'file-key-ready-for-download-acknowledged' }
>;

export const createFileKeyReadyForDownloadAcknowledgedHandler = (
  loggerService: LoggerService
): MessageHandler<FileKeyReadyForDownloadAcknowledgedVariant> => {
  const log = loggerService.createLogger({
    namespace: 'six3ro:p2p:handlers:file-key-ready-for-download-acknowledged',
  });

  return {
    canHandle: (_topic: string, message: MessagePayload): boolean =>
      message.type === 'file-key-ready-for-download-acknowledged',

    process: (
      message: MessagePayload,
      _libp2p: LibP2pWithServices,
      _heliaNode: HeliaNode | null
    ): FileKeyReadyForDownloadAcknowledgedVariant => {
      if (message.type !== 'file-key-ready-for-download-acknowledged') {
        throw new Error(`Invalid message type: expected 'file-key-ready-for-download-acknowledged', got '${message.type}'`);
      }

      log.info(`Received file-key-ready-for-download-acknowledged for ${message.messageId} from ${message.sender}`);

      return {
        type: 'file-key-ready-for-download-acknowledged',
        data: {
          messageId: message.messageId,
          sender: message.sender,
          messageTimestamp: message.timestamp,
        },
      };
    },
  };
};
